import React from 'react';

const Copyright = ({ siteName }) => (
  <div className="copyright">
    <p>© {new Date().getFullYear()} {siteName} All right reserved.</p>
  </div>
);

export default Copyright;
